import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from "@ngrx/store";
import { CurrentState } from "common-lib";
import { Observable, throwError } from "rxjs";
import { catchError, tap } from 'rxjs/operators';
import { PortalAppState } from "../store/reducer";
import { DecreaseLoadingCounterAction, IncreaseLoadingCounterAction } from "../store/ui/ui.actions";
import {BaseInterceptor} from "./base-interceptor";


@Injectable()
export class HttpLoadingCounterInterceptorService extends BaseInterceptor implements HttpInterceptor {
  constructor(protected store: Store<PortalAppState>, protected currentState: CurrentState<PortalAppState>) {
    super(store, currentState);
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.isPingCall(request)) {
      return next.handle(request);
    }
    if (this.isApiRequest(request)) {
      this.store.dispatch(new IncreaseLoadingCounterAction(request.url));
    }
    return next.handle(request).pipe(tap(response => {
      if (response instanceof HttpResponse && this.isApiRequest(request)) {
        this.store.dispatch(new DecreaseLoadingCounterAction(request.url));
      }
      return response;
    }), catchError(error => {
      this.store.dispatch(new DecreaseLoadingCounterAction(request.url));
      return throwError(error)
    }));
  }
}
